export default __webpack_public_path__ + "static/media/binokor.957e283a.jpg";